import './conversions-quantity.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';

const Form = ({
	intl
}) => (
	<form className="conversions-quantity">
		<div className="conversions-quantity__element">
			<Field
				name="perDay"
				placeholder={intl('Per day')}
				showLabel={true}
				component={InputField} />
		</div>
		<div className="conversions-quantity__element">
			<Field
				name="perGroupingPerDay"
				placeholder={intl('Subgroup per day')}
				showLabel={true}
				component={InputField} />
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'conversionsQuantityForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/form/conversions-quantity.js